import React from 'react'
import MEP from '../../assets/me.jpg'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
import CV from '../../assets/Thu Mai Resume.pdf'
import './about.css'
import SocialMedia from './SocialMedia'

const About = () => {
  return (
    <section id='about'>
      <h5>Hello I'm</h5>
      <h2>Thu Mai</h2>

      <div className='container header_container'>
        <SocialMedia />

        <a href='#contact' className='scroll_down' >Scroll Down</a>
      </div>
      <div className='container about_container'>
        <div className='about_me'>
          <div className='about_me_image'>
            <img src={MEP} alt='' />
          </div>
        </div>
        <div className='about_content'>
          <div className='about_cards'>
            <article className='about_card'>
              <FaAward className='about_icon' />
              <h5>Experience</h5>
              <small>4+ Years Working</small>
            </article>

            <article className='about_card'>
              <VscFolderLibrary className='about_icon' />
              <h5>Education</h5>
              <small>Computer Science Wilfrid Laurier University</small>
            </article>

            <article className='about_card'>
              <FiUsers className='about_icon' />
              <h5>Projects</h5>
              <small>3+ Completed</small>
            </article>
          </div>
          <div className='cta'>
            <a href={CV} download className='btn'>Download Resume</a>
            <a href='#contact' className='btn btn-primary'>Let's Connect</a>
          </div>

        </div>

      </div>

    </section>
  )
}

export default About